"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeastCommonMultiple = exports.getSortedMergedStudySpecsByVersion = exports.getNumericOrdinal = exports.paramsMapped = exports.getArrayElemValByIndex = exports.cloneAndSetArrayElemValWithIndex = exports.cloneAndSwapArrayElem = exports.isStudyClosed = exports.isStudyUnwritable = exports.isAuthorizedBySite = exports.isAuthorized = exports.phoneNumberMapper = exports.secondsToReadableString = exports.readablePhoneNumber = exports.readableNumber = exports.dateFormat = exports.splitString = exports.classNames = exports.arrayify = exports.hasOwnProperty = void 0;
const semver_1 = __importDefault(require("semver"));
const study_1 = require("../dto/entity/study");
const dayjs_1 = __importDefault(require("dayjs"));
/** @deprecated 속성 존재 여부를 확인하려면 'in'을 사용하세요. */
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
exports.hasOwnProperty = hasOwnProperty;
function arrayify(e) {
    return Array.isArray(e) ? e : [e];
}
exports.arrayify = arrayify;
function classNames(...args) {
    return args
        .reduce((o, e) => {
        if (typeof e === "string" && e)
            o.push(e);
        else if (Array.isArray(e))
            o.push(classNames(...e));
        else if (e && typeof e === "object") {
            Object.keys(e).forEach(k => {
                if (e[k])
                    o.push(k);
            });
        }
        return o;
    }, [])
        .join(" ");
}
exports.classNames = classNames;
function splitString(val, separator, ...args) {
    let x = args[0];
    let r = val.slice(0, args[0]);
    for (let i = 1; i < args.length; i++) {
        r = r + separator + val.slice(x, x + args[i]);
        x = x + args[i];
    }
    return r;
}
exports.splitString = splitString;
function dateFormat(date, format) {
    return date ? (0, dayjs_1.default)(date).format(format) : "";
}
exports.dateFormat = dateFormat;
function readableNumber(val) {
    val = parseInt(val, 10);
    return isNaN(val) ? "0" : val.toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, "$1,");
}
exports.readableNumber = readableNumber;
function readablePhoneNumber(val, region = "KR", hyphen = "-") {
    if (!val)
        return val;
    val = val.replace(/[^0-9]/gi, "");
    hyphen = hyphen || "-";
    if (val.length < 5) {
        return val;
    }
    if (region === "KR") {
        if (val.length === 5) {
            // 12-345
            return val.substring(0, 2) + hyphen + val.substring(2, 5);
        }
        if (val.length === 6) {
            // 123-456
            return val.substring(0, 3) + hyphen + val.substring(3, 6);
        }
        if (val.length === 7) {
            // 123-4567
            return val.substring(0, 3) + hyphen + val.substring(3, 7);
        }
        if (val.length === 8) {
            // 1234-5678
            return val.substring(0, 4) + hyphen + val.substring(4, 8);
        }
        if (val.length === 9) {
            // 12-345-6789
            return val.substring(0, 2) + hyphen + val.substring(2, 5) + hyphen + val.substring(5, 9);
        }
        if (val.length === 10) {
            // 12-3456-7890, 123-456-7890
            const p2 = val.substring(0, 2);
            if (p2 === "02") {
                return val.substring(0, 2) + hyphen + val.substring(2, 6) + hyphen + val.substring(6, 10);
            }
            return val.substring(0, 3) + hyphen + val.substring(3, 6) + hyphen + val.substring(6, 10);
        }
        if (val.length === 11) {
            // 123-4567-8901
            return val.substring(0, 3) + hyphen + val.substring(3, 7) + hyphen + val.substring(7, 11);
        }
        if (val.length === 12) {
            // 1234-5678-9012
            return val.substring(0, 4) + hyphen + val.substring(4, 8) + hyphen + val.substring(8, 12);
        }
    }
    return val;
}
exports.readablePhoneNumber = readablePhoneNumber;
function secondsToReadableString(sec) {
    if (!sec)
        return "00:00";
    if (sec < 0)
        return "00:00";
    const hour = Math.floor(sec / (60 * 60));
    const minute = Math.floor((sec % (60 * 60)) / 60);
    const remainSec = Math.floor(sec % 60);
    const hourStr = hour > 9 ? hour : `0${hour}`;
    const minuteStr = minute > 9 ? minute : `0${minute}`;
    const secStr = remainSec > 9 ? remainSec : `0${remainSec}`;
    return `${hour > 0 ? hourStr + ":" : ""}${minuteStr}:${secStr}`;
}
exports.secondsToReadableString = secondsToReadableString;
function phoneNumberMapper(val) {
    return val.replace(/[^0-9]/gi, "").slice(0, 11);
}
exports.phoneNumberMapper = phoneNumberMapper;
function isAuthorized(priv, roles) {
    if (!priv || (Array.isArray(priv) && priv.length === 0))
        return true;
    else if (!roles || (Array.isArray(roles) && roles.length === 0))
        return false;
    const privileges = (Array.isArray(priv) ? priv : [priv]).map(x => (typeof x === "string" ? x : x.toString()));
    return !!arrayify(roles).find(x => !!x.privileges.find(y => privileges.indexOf(y) !== -1));
}
exports.isAuthorized = isAuthorized;
function isAuthorizedBySite(priv, studyUserRole, belongsSiteIds, currentSiteId) {
    return isAuthorized(priv, studyUserRole) && belongsSiteIds.includes(currentSiteId);
}
exports.isAuthorizedBySite = isAuthorizedBySite;
function isStudyUnwritable(isLocked, status) {
    return isStudyClosed(status) || isLocked;
}
exports.isStudyUnwritable = isStudyUnwritable;
function isStudyClosed(status) {
    return status === study_1.StudyStatus.Closed;
}
exports.isStudyClosed = isStudyClosed;
function cloneAndSwapArrayElem(arr, oldIndex, newIndex) {
    const items = [...arr];
    const [old] = items.splice(oldIndex, 1);
    items.splice(newIndex, 0, old);
    return items;
}
exports.cloneAndSwapArrayElem = cloneAndSwapArrayElem;
function cloneAndSetArrayElemValWithIndex(elem, index, key, val) {
    return elem.map((iter, iterIdx) => (iterIdx === index ? { ...iter, [key]: val } : { ...iter }));
}
exports.cloneAndSetArrayElemValWithIndex = cloneAndSetArrayElemValWithIndex;
function getArrayElemValByIndex(elem, index, key) {
    const found = elem.find((_, iterIdx) => iterIdx === index);
    if (!found)
        return null;
    return found[key];
}
exports.getArrayElemValByIndex = getArrayElemValByIndex;
function paramsMapped(params, path) {
    const paths = arrayify(path);
    return paths.map(val => {
        if (typeof val !== "string")
            return val;
        Object.keys(params || {}).forEach(k => {
            val = val.split(`:${k}`).join(params[k]);
        });
        return val;
    });
}
exports.paramsMapped = paramsMapped;
function getNumericOrdinal(n) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules
    const pr = new Intl.PluralRules("en-US", { type: "ordinal" });
    const suffixes = new Map([
        ["one", "st"],
        ["two", "nd"],
        ["few", "rd"],
        ["other", "th"],
    ]);
    const rule = pr.select(n);
    const suffix = suffixes.get(rule);
    return `${n}${suffix}`;
}
exports.getNumericOrdinal = getNumericOrdinal;
function getSortedMergedStudySpecsByVersion(mergedStudySpecs) {
    return mergedStudySpecs.sort((a, b) => {
        const aVersion = semver_1.default.coerce(a.studySpec.meta.crfVersion).version;
        const bVersion = semver_1.default.coerce(b.studySpec.meta.crfVersion).version;
        if (semver_1.default.lt(aVersion, bVersion))
            return -1;
        else if (semver_1.default.gt(aVersion, bVersion))
            return 1;
        return 0;
    });
}
exports.getSortedMergedStudySpecsByVersion = getSortedMergedStudySpecsByVersion;
function getLeastCommonMultiple(numbers) {
    const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
    const lcm = (a, b) => (a * b) / gcd(a, b);
    return numbers.reduce((acc, number) => lcm(acc, number), 1);
}
exports.getLeastCommonMultiple = getLeastCommonMultiple;
//# sourceMappingURL=misc.js.map